import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs, SpaceXs, ColorWhite, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
const LegalText = ({
  text,
  variant = "default",
  isSmall
}) => {
  return /* @__PURE__ */ jsx(
    Text,
    {
      sx: {
        background: ColorGray900,
        borderBottomLeftRadius: variant === "default" && !isSmall ? { md: "10px" } : void 0,
        color: ColorWhite,
        padding: `${SpaceXxs} ${SpaceXs}`,
        textAlign: "left",
        width: "100%"
      },
      variant: "t7",
      children: text
    }
  );
};
export {
  LegalText
};
